import React from 'react';
// components
// import {
//   FaRegCopy, FaLaptop, FaUserPlus, FaUserFriends
// } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
// styles
// import {ListGroup, Row, Col} from 'react-bootstrap';
import './style.css';
import { object } from 'yup';

const VerticalMenu = ({url="", lang={}, menu=[]})=> {

  let navigate = useNavigate();
  return (
    <>

      <div className="card">
        <ul className="list-group list-group-flush">
          {
            menu.map((item) =>{
              if(item.href !== url){
                return <li className="item" key={item.key} onClick={()=>navigate(item.href)}>
                  {item.title}
                </li>;
              }else{
                return <li className="item-title" key={item.key}>
                  <img 
                    className="card-img-top" 
                    crossOrigin="anonymous" 
                    src={item.image} alt="" 
                    style={{ height:'200px', objectFit:'cover' }} 
                    />
                  <div >{item.title}</div>
                </li>
              }
            })
          }
        </ul>
    </div>
      {/* </Col> */}
    </>
  );
};

export default VerticalMenu;